import { connect } from 'react-redux'
import { showAlert } from '../utils/Alert'
import {
  fetchNotifications,
  receiveNotification,
  fetchUserSettings,
  receiveUserSettings,
  putUserSettings,
  setUserSettings,
  closeTrainOperation,
  lineReverse,
  nextNotification,
} from '../actions'
import TrainOperationInfo from '../components/train_positions/TrainOperationInfo'

const mapStateToProps = state => {
  const { notifications, showingNext, reverseFlag, updatedAt } = state.trainPositionReducer
  const { themeName } = state.themeReducer
  const { trainPositionAutoRefresh, popinfoId } = state.userSettingsReducer

  return {
    showingNext,
    notifications,
    reverseFlag,
    updatedAt,
    themeName,
    trainPositionAutoRefresh,
    popinfoId,
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    fetchNotifications: async () => {
      try {
        const payload = await fetchNotifications()
        dispatch(receiveNotification(payload))
      } catch (error) {
        showAlert('運行情報が取得できませんでした')
      }
    },
    fetchUserSettings: async (popinfoId) => {
      try {
        if (!popinfoId) {
          return true
        }
        const payload = await fetchUserSettings(popinfoId)
        dispatch(receiveUserSettings(payload))
      } catch (error) {
        showAlert('設定を取得できませんでした')
      }
    },
    changeTrainPositionAutoRefresh: async (popinfoId, enableAutoRefresh) => {
      try {
        const payload = {
          'train_position_auto_refresh': enableAutoRefresh
        }
        if (popinfoId) {
          await putUserSettings(popinfoId, payload)
        }
        dispatch(setUserSettings(payload))
      } catch (error) {
        showAlert('設定を更新できませんでした')
      }
    },
    closeTrainOperation: () => {
      dispatch(closeTrainOperation())
    },
    nextNotification: () => {
      dispatch(nextNotification())
    },
    lineReverse: () => {
      dispatch(lineReverse())
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TrainOperationInfo)

